import { combineReducers } from 'redux';
import errors from './errors';
import orders from './orders';
import order from './order';
import merchant from './merchant';

const rootReducer = combineReducers({
  errors,
  merchant,
  orders,
  order,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js